import useSWR from "swr/immutable"

import { WithFailureInfraCmtResponse } from "~/@shared/api-types/InfraCmtResponse"
import {
  HasIdDisplay,
  HasIdName,
  HasIdNameDisplayOrder,
  HasIdNameDisplayOrderRank,
  HasStrIdName,
} from "~/@shared/api-types/id-name-display"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

// MasterData
export type GetAuthRegister = {
  /** 学年 */
  school_grades: Array<string>
  /** 卒業年度 */
  graduation_years: Array<number>
  /** 学科系統 */
  categories: Array<HasIdName>
  application_categories: Array<HasIdDisplay>
  job_hunting_statuses: Array<HasStrIdName>
  industries: Array<HasIdNameDisplayOrder>
  company_types: Array<HasIdDisplay>
  student_experience_types: Array<HasIdNameDisplayOrderRank>
  student_achievement_types: Array<HasIdNameDisplayOrderRank>
  experience_periods: Array<string>
  /** 興味のある職種 */
  major_occupations: Array<HasIdName>
  occupations: Array<MajorOccupation>
  /** 1週間の出勤可能日数 */
  days_for_work: Array<HasIdDisplay>
  /** 1週間の出勤可能な平日の日数 */
  days_for_work_in_weekday: Array<HasIdDisplay>
  intern_periods: Array<HasIdDisplay>
}

type MajorOccupation = HasIdName & {
  minor_occupations: Array<MinorOccupation>
}

type MinorOccupation = HasIdName & {
  major_occupation_id: number
}

const PATH = "/auth/register"

export const fetchGetAuthRegister = defineFetcher((): Promise<WithFailureInfraCmtResponse<GetAuthRegister>> => {
  return GET(PATH)
})

export const useSWRForGetAuthRegister = () => {
  return useSWR(PATH, fetchGetAuthRegister)
}
